import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { siteConfig } from '../config/site';

const groupCompanies = [
  {
    name: 'Smart Castings and Engineerings',
    logo: '/images/logo/smart_castings.png',
    href: null
  },
  {
    name: 'Smart Power Controls',
    logo: '/images/logo/smart_power_controls.jpeg',
    href: siteConfig.smartPowerControlsUrl
  },
  {
    name: 'Smart Broadband',
    logo: '/images/logo/smart_broadband.png',
    href: null
  }
];

const GroupCompanies = () => {
  const [sectionRef, sectionVisible] = useScrollAnimation(0.2);

  return (
    <section className="py-16 bg-gradient-to-b from-black to-gray-900">
      <div
        ref={sectionRef}
        className={`max-w-6xl mx-auto px-6 scroll-fade-in ${sectionVisible ? 'visible' : ''}`}
      >
        <div className="text-center">
          <p className="text-[11px] uppercase tracking-[0.3em] text-blue-400">
            Group Network
          </p>
          <h2 className="mt-3 text-3xl md:text-4xl font-semibold text-white">
            Group Companies
          </h2>
          <p className="mt-4 max-w-3xl mx-auto text-gray-400 leading-relaxed">
            Business entities aligned with Smart Automation and LV Systems across complementary infrastructure and service domains.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          {groupCompanies.map((company) => (
            <a
              key={company.name}
              href={company.href || undefined}
              target={company.href ? '_blank' : undefined}
              rel={company.href ? 'noreferrer' : undefined}
              className={`block rounded-2xl border border-white/10 bg-white/[0.03] px-6 py-7 backdrop-blur-md transition-all duration-300 hover:border-blue-500/25 hover:bg-white/[0.05] ${company.href ? 'cursor-pointer' : 'cursor-default'}`}
            >
              <div className="flex h-16 items-center justify-center">
                {company.logo ? (
                  <img
                    src={company.logo}
                    alt={company.name}
                    className="max-h-full max-w-[82%] object-contain"
                    loading="lazy"
                  />
                ) : (
                  <span className="text-sm font-semibold uppercase tracking-[0.24em] text-white/75 text-center">
                    {company.name}
                  </span>
                )}
              </div>
              <p className="mt-5 text-center text-base font-medium text-white">
                {company.name}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GroupCompanies;
